import * as React from "react";
import type { SVGProps } from "react";

const FacilityBus = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5878 15.836H5.41736C4.49614 15.836 3.75 15.0898 3.75 14.1686V4.99811C3.75 3.6167 4.86963 2.49707 6.25104 2.49707H13.7542C15.1356 2.49707 16.2552 3.6167 16.2552 4.99811V14.1686C16.2552 15.0898 15.5091 15.836 14.5878 15.836Z"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.25 13.3348H7.08368"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.918 13.3348H13.7516"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.86432 15.8362V17.0867C6.86432 17.5469 6.49083 17.9204 6.03064 17.9204H5.19696C4.73677 17.9204 4.36328 17.5469 4.36328 17.0867V15.4561"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.6417 15.4561V17.0867C15.6417 17.5469 15.2682 17.9204 14.808 17.9204H13.9743C13.5141 17.9204 13.1406 17.5469 13.1406 17.0867V15.8362"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.2539 5.83203H17.5044C17.9646 5.83203 18.3381 6.20552 18.3381 6.66571V9.16675"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.74826 5.83203H2.49774C2.03755 5.83203 1.66406 6.20552 1.66406 6.66571V9.16675"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.297 3.03487L13.8222 4.50965C13.5096 4.82228 13.0852 4.99819 12.6434 4.99819H7.35449C6.91264 4.99819 6.4883 4.82228 6.17567 4.50965L4.69922 3.0332"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.2552 10.8338H3.75"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
FacilityBus.displayName = "FacilityBus";

export default FacilityBus;
